module.exports = __webpack_public_path__ + "img/brand-logo-mobile.b01819b2.png";